import Home from './components/Home';
import Layout from './components/Layout';
import Login from './components/Login';
import RequireAuth from './components/RequireAuth';
import Faqs from './components/Faqs';
import AddFaq from './components/AddFaq';
import DeleteFaq from './components/DeleteFaq';
import Contacts from './components/Contacts';
import AddContact from './components/AddContact';
import DeleteContact from './components/DeleteContact';
import Configs from './components/Configs';
import AddFlowConfig from './components/AddFlowConfig';
import DeleteConfig from './components/DeleteConfig';
import EditFlowConfig from './components/EditFlowConfig';
import Users from './components/Users';
import AddUser from './components/AddUser';
import EditUser from './components/EditUser';
import DeleteUser from './components/DeleteUser';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import Numbers from './components/Numbers';
import { AuthProvider } from './context/AuthProvider';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

function App() {
    return (
        <BrowserRouter future={{v7_startTransition: true, v7_relativeSplatPath: true}}>
            <AuthProvider>
                <Routes>
                    <Route path="login" element={<Login />} />
                    <Route path="forgot-password" element={<ForgotPassword />} />
                    <Route path="reset-password" element={<ResetPassword />} />
                    <Route path="/" element={<Layout />}>
                        <Route element={<RequireAuth />}>
                            <Route path="/" element={<Home />} />

                            <Route path="/faqs" element={<Faqs />} />
                            <Route path="/add-faq" element={<AddFaq />} />
                            <Route path="/faqs/:faqId" element={<DeleteFaq />} />

                            <Route path="/contacts" element={<Contacts />} />
                            <Route path="/add-contact" element={<AddContact />} />
                            <Route path="/contacts/:contactId" element={<DeleteContact />} />

                            <Route path="/configs" element={<Configs />} />
                            <Route path="/add-config" element={<AddFlowConfig />} />
                            <Route path="/delete-flow-configs/:confId" element={<DeleteConfig />} />
                            <Route path="/edit-flow-configs/:confId" element={<EditFlowConfig />} />

                            <Route path="/users" element={<Users />} />
                            <Route path="/add-user" element={<AddUser />} />
                            <Route path="/edit-user/:userId" element={<EditUser />} />
                            <Route path="/delete-user/:userId" element={<DeleteUser />} />

                            <Route path="/chats" element={<Numbers />} />
                        </Route>
                    </Route>
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
